import { captureProPreview } from "@/features/billing";

// Ссылка с `?pro=1` включает показ платного (Pro в меню, «Тарифы», реквизиты) до запуска оплаты,
// `?pro=0` выключает. Читается до роутера, как и источник перехода.
export const rememberProPreview = (): void => {
  captureProPreview();
};
